import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import { push } from "react-router-redux";
import Helper from "../../helpers/helpers";

const delay = (ms) => new Promise(res => setTimeout(res, ms))



export function* loadVendingCount() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNT");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCount(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {

          yield put(actions.loadVendingCountSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingCountFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadVendingCountFail());
    }
  });
}


export function* loadVendingLocationList() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_LOCATION_LIST, function*(action) {

    if(!action.data) action.data = {}

    let listing = (action.data.listing) ? "1" : ""
    let state = (action.data.state) ? action.data.state : ""

    let track_no = Helper.generateTrackNo(`VENDINGLOCATIONLIST${state}${listing}`);
    
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingLocationList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
      
          yield put(actions.loadVendingLocationListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingLocationListFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadVendingLocationListFail());
    }
  });
}

export function* loadVendingList() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_LIST, function*(action) {


    if(!action.data) action.data = {}

    let nodumpster = (action.data.without_dumpster) ? "nd" : ""
    let withdumpster = (action.data.with_dumpster) ? "wd" : ""
    let category_id = (action.data.category_id) ? action.data.category_id : ""

    let track_no = Helper.generateTrackNo(`VENDINGLIST${nodumpster}${withdumpster}${category_id}`);
    
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
          
          let params = {
            data: response.data.data,
            offset: action.data.offset,
            limit: action.data.limit,
            total_result: response.data.data.length,
            total: response.data.total,
          }
          
          yield put(actions.loadVendingListSuccess(params));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingListFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadVendingListFail());
    }
  });
}


export function* loadVendingDetail() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGDETAIL");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingDetail(action.id, action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
      
          yield put(actions.loadVendingDetailSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingDetailFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {

      if (error.response && error.response.status && error.response.data && error.response.data.duplicate) {

        yield put(actions.loadVendingDetailDuplicate());
        
      }else{

        yield put(actions.handleAPIError(error));
        // yield put(actions.disableLoading());
        yield put(actions.loadVendingDetailFail());
      }
    }
  });
}


export function* createVending() {
  yield takeEvery(actionTypes.CREATE_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATEVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());
    
    try {
      const response = yield API.createVending(action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.createVendingSuccess());
          yield put(actions.msgSuccess(response.data.message));
          yield put(push("/vending"));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.createVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.createVendingFail());
    }
  });
}

export function* updateVending() {
  yield takeEvery(actionTypes.UPDATE_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.updateVending(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.updateVendingSuccess());
          yield put(actions.msgSuccess(response.data.message));
          yield put(push("/vending"));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.updateVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.updateVendingFail());
    }
  });
}

export function* resetPwd() {
  yield takeEvery(actionTypes.RESET_PWD_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RESETPWDVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.resetPwd(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.resetPwdSuccess());
          yield put(actions.msgSuccess(response.data.message));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.resetPwdFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.resetPwdFail());
    }
  });
}

export function* delVending() {
  
  yield takeEvery(actionTypes.REMOVE_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());
    try {
      const response = yield API.delVending(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.delVendingSuccess());
          yield put(actions.msgSuccess(response.data.message));
          yield put(push("/vending"));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.delVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.delVendingFail());
    }
  });
}


export function* rebootVending() {
  yield takeEvery(actionTypes.REBOOT_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REBOOTVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.rebootVending(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.rebootVendingSuccess());
          yield put(actions.msgSuccess(response.data.message));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.rebootVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.rebootVendingFail());
    }
  });
}


export function* stopVending() {
  yield takeEvery(actionTypes.STOP_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("STOPVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.stopVending(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.stopVendingSuccess());
          // yield put(actions.msgSuccess(response.data.message));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.stopVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.stopVendingFail());
    }
  });
}



export function* startVending() {
  yield takeEvery(actionTypes.START_VENDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("STARTVENDING");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.startVending(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          
          yield delay(1000);
          yield put(actions.startVendingSuccess());
          // yield put(actions.msgSuccess(response.data.message));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.startVendingFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.startVendingFail());
    }
  });
}


export function* testConnection() {
  yield takeEvery(actionTypes.VENDING_TEST_CONNECTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGTESTCONNECTION");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.testConnection(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          yield put(actions.testConnectionSuccess(response.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.testConnectionFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.testConnectionFail());
    }
  });
}

export function* setPlacement() {
  yield takeEvery(actionTypes.VENDING_SET_PLACEMENT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGSETPLACEMENT");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.setPlacement(action.id, action.data);
      if(response)
      {
        if (response.data.success) {
          yield delay(1000);
          yield put(actions.setPlacementSuccess());
          yield put(actions.msgSuccess(response.data.message));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.setPlacementFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.setPlacementFail());
    }
  });
}

export function* loadVendingCouncilList() {
  yield takeEvery(actionTypes.LOAD_VENDING_COUNCIL_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILLIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCouncilList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
          yield put(actions.loadVendingCouncilListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingCouncilListFail());
        }
      }
      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadVendingCouncilListFail());
    }
  });
}

export default function* vendingSaga() {
  
  yield all([fork(loadVendingLocationList)]);
  yield all([fork(loadVendingList)]);
  yield all([fork(loadVendingCount)]);
  yield all([fork(loadVendingDetail)]);
  yield all([fork(createVending)]);
  yield all([fork(updateVending)]);
  yield all([fork(resetPwd)]);
  yield all([fork(delVending)]); 
  yield all([fork(rebootVending)]);
  yield all([fork(stopVending)]);
  yield all([fork(startVending)]);
  yield all([fork(testConnection)]);
  yield all([fork(setPlacement)]);
  yield all([fork(loadVendingCouncilList)]);
}
